import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';
import { parseEventDates } from '../../util/eventDateHelpers';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const formatEventDateTextMaybe = text => {
  if (typeof text !== 'string' && typeof text !== 'number' && !Array.isArray(text)) {
    return text;
  }

  const parsedDates = parseEventDates(text);
  if (parsedDates.length === 0) {
    return text;
  }

  return parsedDates
    .map(ts =>
      new Date(ts).toLocaleDateString('en-GB', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    )
    .join(', ');
};

/**
 * Helper: Check if a value is "empty" (not displayable)
 * Returns true if value should be hidden
 */
const isEmptyValue = (value) => {
  return (
    value == null ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
};

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  
  // TASK003: Hide section if text is empty (conditional rendering for optional premium fields)
  if (isEmptyValue(text)) {
    return null;
  }
  
  const textClass = showAsIngress ? css.ingress : css.text;
  const displayText =
    heading === 'Event Date' || heading === 'Event Dates' ? formatEventDateTextMaybe(text) : text;
  const content = richText(displayText, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  );
};

export default SectionTextMaybe;
